import { useRef, forwardRef } from 'react';
import styles from './FJFileUpload.module.less';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
const FJFileUpload = (props, refs) => {
    const {
        accept = UPLOAD_FILE_TYPE_NO_GIF,
        onUpload,
        children,
        className,
        multiple = false,
        onClick,
        disabled = false,
        dragCallback,
    } = props;
    const inputRef = useRef(null);
    const _onChange = e => {
        if (multiple) {
            const files = e.target.files;
            onUpload(files);
        } else {
            const file = e.target.files[0];
            onUpload(file);
        }
        e.target.value = null;
    };

    const _onclick = e => {
        if (disabled) return;
        if (onClick) onClick();
        else inputRef.current.click();
    };
    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        dragCallback && dragCallback('drop');

        let files = Array.from(e.dataTransfer.files);
        if (files && files.length > 0) {
            if (multiple) {
                onUpload(files);
            } else {
                const file = files[0];
                onUpload(file);
            }
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        dragCallback && dragCallback('over');
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        dragCallback && dragCallback('leave');
    };
    return (
        <div
            className={className}
            onClick={_onclick}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            {children}
            <input
                multiple={multiple}
                type='file'
                ref={inputRef}
                accept={accept}
                className={styles.input}
                onChange={_onChange}
            />
        </div>
    );
};

export default forwardRef(FJFileUpload);
